export function isWalletId(params) {
    return !!params.walletId && !params.externalWalletAddress;
}
export function isExternalWalletAddress(params) {
    return !!params.externalWalletAddress && !params.walletId;
}
export function extractWalletRef(params) {
    if (isWalletId(params)) {
        return ['walletId', params.walletId];
    }
    else if (isExternalWalletAddress(params)) {
        return ['externalWalletAddress', params.externalWalletAddress];
    }
    throw new Error('invalid wallet params');
}
